import { formatDate } from "@certn/utils";
import { useTranslation } from "react-i18next";

export function useFormatDisplayDate() {
  const { t } = useTranslation();

  const formatDisplayDate = ({ start_date, end_date }: Record<string, any>) => {
    return `${formatDate(start_date, "MMM yyyy")} - ${
      end_date ? formatDate(end_date, "MMM yyyy") : t("Present")
    }`;
  };

  return { formatDisplayDate };
}
